module.exports = __webpack_public_path__ + "img/rapi_icon_mobile.9f17968d.png";